module.exports = __webpack_public_path__ + "static/media/Voucher-active.d8909122.svg";